<template>
  <div class="main-container">
    <div class="section-one-container">
      <div class="container-fluid navbar-container">
        <div class="row content">
          <div class="col-md-8 col-sm-6 col-6 d-flex align-items-center justify-content-start nav-left-col">
            <div class="logo-wrapper">
              <img src="@/assets/i911-logo-2025.svg" alt="i911 Logo" class="logo" @click="goToSite" />
            </div>
            <LanguageDropdown
              light
              no-offset
              class="homepage-lang-dropdown"
              style="margin-left: 3rem !important"
            />
          </div>
          <div class="col-md-4 col-sm-6 col-6 d-flex align-items-center justify-content-end">
            <!-- Mobile Menu Toggle -->
            <div class="mobile-menu-toggle d-md-none" @click="toggleMobileMenu">
              <span class="hamburger-line" :class="{ 'active': isMobileMenuOpen }"></span>
              <span class="hamburger-line" :class="{ 'active': isMobileMenuOpen }"></span>
              <span class="hamburger-line" :class="{ 'active': isMobileMenuOpen }"></span>
            </div>
            <!-- Desktop Navigation -->
            <div class="nav-items d-none d-md-flex">
              <span class="nav-item" @click="sectionTwo">{{ $t('homepage.navigation.platform') }}</span>
              <span class="nav-item" @click="sectionThree">{{ $t('homepage.navigation.learn') }}</span>
              <span class="nav-item" @click="goToAbout">{{ $t('homepage.navigation.about') }}</span>
              <v-btn id="signin-btn" class="error" outlined @click="showSignInModal=true">{{ $t('homepage.navigation.signIn') }}</v-btn>
              <v-btn id="signup-btn" class="primary" @click="showSignUpModal=true">{{ $t('homepage.navigation.signUp') }}</v-btn>
            </div>
          </div>
        </div>
      </div>
      <!-- Mobile Navigation Menu -->
      <div class="mobile-menu d-md-none" :class="{ 'open': isMobileMenuOpen }">
        <div class="mobile-nav-items">
          <span class="mobile-nav-item" @click="closeMobileMenu(); sectionTwo();">{{ $t('homepage.navigation.platform') }}</span>
          <span class="mobile-nav-item" @click="closeMobileMenu(); sectionThree();">{{ $t('homepage.navigation.learn') }}</span>
          <span class="mobile-nav-item" @click="goToAbout">{{ $t('homepage.navigation.about') }}</span>
          <div class="mobile-btn-container">
            <v-btn id="mobile-signin-btn" class="error" outlined block @click="closeMobileMenu(); showSignInModal=true">{{ $t('homepage.navigation.signIn') }}</v-btn>
            <v-btn id="mobile-signup-btn" class="primary" block @click="closeMobileMenu(); showSignUpModal=true">{{ $t('homepage.navigation.signUp') }}</v-btn>
          </div>
        </div>
      </div>
      <div 
        v-if="isMobileMenuOpen" 
        class="mobile-menu-backdrop d-md-none" 
        @click="closeMobileMenu"
      ></div>
    </div>
    <SignInModal v-model="showSignInModal"/>
    <SignUpModal v-model="showSignUpModal"/>
  </div>
</template>

<script>
import SignInModal from './SignInModal.vue';
import SignUpModal from './SignUpModal.vue';

export default {
  name: 'Navigation',
  data() {
    return {
      isMobileMenuOpen: false,
      showSignInModal: false,
      showSignUpModal: false,
    };
  },
  methods: {
    goToPlatform() {
      if (this.$route.name === 'about') {
        this.$router.push('/');
      }
      this.$emit('sectionTwo', 'section-two');
      this.closeMobileMenu();
    },
    goToLearn() {
      this.$emit('sectionThree', 'section-three');
      this.closeMobileMenu();
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },
    goToAbout() {
      if (this.$route.name != 'about') {
        this.$router.push('/about').then(() => {
          this.$nextTick(() => {
            window.scrollTo(0, 0);
          });
        });
        this.closeMobileMenu();
      }
    },
    sectionTwo() {
      if (this.$route.name === 'about') {
        this.$router.push('/').then(() => {
          this.$nextTick(() => {
            window.scrollTo(0, 0);
          });
        });
        return;
      }
      this.$emit('sectionTwo', 'section-two');
    },
    sectionThree() {
      if (this.$route.name === 'about') {
        this.$router.push('/').then(() => {
          this.$nextTick(() => {
            window.scrollTo(0, 0);
          });
        });
        return;
      }
      this.$emit('sectionThree', 'section-three');
    },
    goToSite() {
      if (this.$route.name === 'about') {
        this.$router.push('/').then(() => {
          this.$nextTick(() => {
            window.scrollTo(0, 0);
          });
        });
      }
    }
  },
  components: {
    SignInModal,
    SignUpModal
  }
};
</script>

<style scoped>
.navbar-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 0;
  margin: 0;
  background-color: #FFFFFF;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.content {
  padding: 0.2rem 1.3rem;
  margin: 0;
  min-height: auto;
  align-items: center;
}

.nav-left-col {
  align-items: center;
}

.nav-left-col .homepage-lang-dropdown {
  display: flex;
  align-items: center;
  align-self: center;
}

.logo-wrapper {
  display: inline-block;
  position: relative;
  flex-shrink: 0;
  /* Safari-specific fixes */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.logo {
  height: 50px;
  width: auto;
  cursor: pointer;
  transition: transform 0.2s ease;
  display: block;
  /* Safari-specific fixes */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

/* Safari-specific fix for logo positioning */
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  .logo-wrapper {
    position: absolute !important;
    left: 0 !important;
    top: 50% !important;
    transform: translateY(-50%) translateZ(0) !important;
    -webkit-transform: translateY(-50%) translateZ(0) !important;
  }
  
  .col-md-8.col-sm-6.col-6 {
    position: relative !important;
  }
}

.nav-items {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.51rem;
  font-size: 0.96rem;
  width: 100%;
}

.nav-item {
  cursor: pointer;
  font-weight: 500;
  letter-spacing: 0.02em;
  transition: color 0.3s ease, transform 0.3s ease;
  font-family: 'Roboto', sans-serif;
  font-size: 0.96rem;
  color: #333;
  padding: 0.54rem 0;
  line-height: 1.4;
}

.nav-item:hover {
  color: #1E40AF;
  transform: scale(1.05);
}

#signup-btn {
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
  border-radius: 2rem;
  font-size: 0.84rem;
  letter-spacing: 0.06rem;
  border-width: 2px;
  height: 40px !important;
}

#signup-btn:hover {
  background-color: rgb(209, 4, 4) !important;
}

#signin-btn {
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
  border-radius: 2rem;
  font-size: 0.84rem;
  letter-spacing: 0.06rem;
  color: rgb(209, 4, 4);
  border-width: 2px;
  border-color: rgb(209, 4, 4);
  background-color: white !important;
  height: 40px !important;
}

#signin-btn:hover {
  color: #1E40AF !important;
  border-color: #1E40AF !important;
  border-width: 2px;
}

#signup-btn {
  margin-left: -0.75rem !important;
}

.mobile-menu-toggle {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 32px;
  height: 25px;
  cursor: pointer;
  z-index: 1001;
  margin-left: auto;
  margin-top: 10%;
  transform: translateY(-50%);
}

.hamburger-line {
  width: 100%;
  height: 3px;
  background-color: #333;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.hamburger-line.active:nth-child(1) {
  transform: rotate(45deg) translate(0, 6px);
}

.hamburger-line.active:nth-child(2) {
  opacity: 0;
}

.hamburger-line.active:nth-child(3) {
  transform: rotate(-45deg) translate(0, -6px);
}

/* Mobile Navigation Menu */
.mobile-menu {
  position: fixed;
  top: 0;
  right: -300px;
  width: 300px;
  height: 100vh;
  background-color: #FFFFFF;
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.15);
  transition: right 0.3s ease;
  z-index: 999;
  display: flex;
  flex-direction: column;
  padding-top: 66px;
}

.mobile-menu.open {
  right: 0;
}

.mobile-nav-items {
  display: flex;
  flex-direction: column;
  padding: 0 2rem;
}

.mobile-nav-item {
  cursor: pointer;
  font-weight: 500;
  letter-spacing: 0.02em;
  font-family: 'Roboto', sans-serif;
  font-size: 1.07rem;
  color: #333;
  padding: 0.81rem 0;
  line-height: 1.4;
  transition: color 0.3s ease;
  border-bottom: 1px solid #e5e7eb;
}

.mobile-nav-item:hover {
  color: #1E40AF;
}

.mobile-nav-item:last-of-type {
  border-bottom: none;
}

.mobile-btn-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
  padding: 0 2rem;
}

#mobile-signin-btn,
#mobile-signup-btn {
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
  border-radius: 2rem;
  font-size: 0.93rem;
  letter-spacing: 0.06rem;
  height: 44px !important;
}

#mobile-signin-btn {
  color: rgb(209, 4, 4);
  border-color: rgb(209, 4, 4);
  background-color: white !important;
}

#mobile-signup-btn {
  background-color: rgb(209, 4, 4) !important;
  color: white !important;
}

/* Mobile Menu Backdrop */
.mobile-menu-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
  backdrop-filter: blur(2px);
}

.background-photo-container {
  flex: 1;
  width: 100%;
  overflow: hidden;
  position: relative;
  min-height: 0;
}

.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}

.hero-content {
  position: absolute;
  top: 35%;
  right: 5rem;
  transform: translateY(-50%);
  text-align: left;
  color: white;
  z-index: 2;
  max-width: 43%;
}

.hero-title {
  font-size: 2.2rem;
  font-weight: 400;
  letter-spacing: 0.02rem;
  line-height: 1.2;
  margin-bottom: 2rem;
  font-family: 'Roboto', sans-serif;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
}

.hero-subtitle {
  font-size: 1.5rem;
  font-weight: 400;
  letter-spacing: 0.02rem;
  line-height: 1.4;
  margin: 0;
  font-family: 'Roboto', sans-serif;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
}

#demo-btn {
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
  border-radius: 2rem;
  font-size: 1rem;
  letter-spacing: 0.08rem;
  color: white;
  border-width: 3px;
  border-color: white !important;
  background-color: #1E40AF !important;
}

.footer {
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}

.footer-text {
  color: white;
  font-family: 'Roboto', sans-serif;
  font-size: .95rem;
  font-weight: 700;
  letter-spacing: 0.02rem;
  text-align: center;
  margin: 0;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
}


</style>